import { useState } from 'react'
import './circle.css'
import { TOPIC_LIST } from '../../../common/utils/constants'

const SingleCircle = ({
  value,
  size = 21,
  filledColor = '#33B2E1',
  emptyColor = 'transparent',
  countryCode,
  topic,
}) => {
  const [isHovered, setIsHovered] = useState(false)
  const renderCircles = () => {
    let circles = []

    // Render the partially filled circle.
    const grad_id = `gradientFill-${countryCode}-${topic}-${value}`
    const gradFill = `url(#${grad_id})`
    circles.push(
      <svg
        key={`svg-${grad_id}`}
        width={29}
        height={29}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <defs>
          <linearGradient id={grad_id} x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" stopColor={filledColor} />
            <stop
              offset={value + '%'}
              stopColor={filledColor}
              stopOpacity="1"
            />
            <stop offset={value + '%'} stopColor={emptyColor} stopOpacity="1" />
            <stop offset="100%" stopColor={emptyColor} stopOpacity="1" />
          </linearGradient>
        </defs>
        <circle
          // key={`grad-${countryCode}-${topic}-${grad_id}`}
          cx={size / 2}
          cy={size / 2}
          r={size / 2}
          fill={gradFill}
          stroke="lightgray"
        />
      </svg>
    )

    return circles
  }

  return (
    <>
      {renderCircles()}
      {isHovered && (
        <div className="pillar-tooltip">
          {TOPIC_LIST.find((item) => item.id === topic)?.name}: {value}
        </div>
      )}
    </>
  )
}

export default SingleCircle
